import './index.less';
import { useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SystemManageArea from '@/global/components/system-area';
import ProjectListPanel from '@/panel/desktop/project-list';
import LibDevicePanel from '@/panel/desktop/lib-device';
import LibMonitorObjectPanel from '@/panel/desktop/lib-monitor-object';
import ConstitutiveRelationPanel from '@/panel/desktop/lib-constitutive-relation';
import LibUserPanel from '@/panel/desktop/lib-user';
import LibPositionPanel from '@/panel/desktop/lib-position';
import { LIB_NAV_LIST } from '@/enums/lib-nav';
import classNames from 'classnames';
import localStore, { LOCAL_USER_TYPE } from '@/global/store/local-store';
import { USER_TYPE } from '@/enums/user';
import CryptoJS from 'crypto-js';


export default function DesktopMain() {
    const navigate = useNavigate();
    const location = useLocation();
    const [hoverUrl, setHoverUrl] = useState<string>('');



    const getNavIcon = (item) => {
        let normal = !!item?.normalIcon;
        if (!normal) return;
        let hover = hoverUrl === item?.url;
        let active = location.pathname === item?.url;

        if (active) {
            return item.activeIcon ? <item.activeIcon /> : null;
        }
        if (hover) {
            return item.hoverIcon ? <item.hoverIcon /> : null;
        }

        return item.normalIcon ? <item.normalIcon /> : null;
    };



    return (
        <div className="desktop-layout-container">
            <SystemManageArea />
            <div className='desktop-layout-panel'>
                <div className='left-nav-panel'>
                    {LIB_NAV_LIST.map((item, key) => {
                        let userType = localStore.get(LOCAL_USER_TYPE);
                        // 演示用户只能查看项目列表
                        if (userType === CryptoJS.MD5(USER_TYPE.TEST.toString()).toString() && item.url !== '/desktop/project-list') {
                            return <></>
                        }
                        // 普通用户不能查看用户和职位
                        if (userType === CryptoJS.MD5(USER_TYPE.NORMAL.toString()).toString() 
                            && (item.url === '/desktop/user' || item.url === '/desktop/position')) {
                            return <></>
                        }
                        return (
                            <div className={classNames({
                                'nav-block': true,
                                'nav-block-hover': hoverUrl === item?.url,
                                'nav-block-active': location.pathname === item?.url,
                                'nav-block-pointer': !!item?.url,
                            })} key={key}
                                onMouseEnter={() => {
                                    if (!item?.url) return;
                                    setHoverUrl(item.url);
                                }}
                                onMouseLeave={() => setHoverUrl(null)}
                                onClick={() => {
                                    if (!item?.url) return;
                                    navigate(item?.url);
                                }}
                            >
                                {getNavIcon(item)}
                                {item.label}
                            </div>
                        )

                    })}
                </div>
                <div className='right-nav-panel'>
                    <Routes>
                        <Route path='project-list' element={<ProjectListPanel />} />
                        <Route path='device' element={<LibDevicePanel />} />
                        <Route path='monitor-object' element={<LibMonitorObjectPanel />} />
                        <Route path='relation' element={<ConstitutiveRelationPanel />} />
                        <Route path='user' element={<LibUserPanel />} />
                        <Route path='position' element={<LibPositionPanel />} />
                        <Route path='*' element={<Navigate to="/project-list" />} />
                    </Routes>
                </div>
            </div>
        </div>
    )
}